﻿
/**
 * This file includes vendor libraries required for the application
 * Vendor library are bundled in a separated file
 */



import '@angular/platform-browser';
import '@angular/core';
import '@angular/common';
import '@angular/common/http';
import '@angular/router';
import '@angular/animations';


import 'rxjs';

import '@ng-bootstrap/ng-bootstrap';

//zip required by wijmo.xlsx
//see: https://www.grapecity.com/en/forums/wijmo/export-flex-grid-to-excel-_1
import 'script-loader!jszip/dist/jszip.min.js'

//wijmo
import 'wijmo/wijmo';
import 'wijmo/wijmo.xlsx';
import 'wijmo/wijmo.grid.xlsx';
import 'wijmo/wijmo.angular2.grid';
import 'wijmo/wijmo.angular2.grid.detail';
import 'wijmo/wijmo.angular2.grid.filter';
import 'wijmo/wijmo.angular2.grid.grouppanel';
import 'wijmo/wijmo.angular2.grid.multirow';
import 'wijmo/wijmo.angular2.input';



//notifications
import 'angular2-notifications';
import '@ngx-progressbar/core';
import '@ngx-progressbar/http'

//error handling
import 'stacktrace-js';

//resize component
import 'angular-resizable-element';



// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...